import {Component, Input, OnInit, ViewEncapsulation} from "@angular/core";
import {MatDialog} from "@angular/material/dialog";
import {AppScope} from "../../services/app_scope.service";
import {InlineStyleMenuComponent} from "../../components/inline_style_menu.component";
import {CommonModule} from "@angular/common";

@Component({
    selector: 'flowchart-series-component',
    encapsulation: ViewEncapsulation.None,
    templateUrl: 'flowchart_series_component.component.html',
    imports: [
        CommonModule,
        InlineStyleMenuComponent
    ],
    styleUrls: ['flowchart.less']
})

export class FlowchartSeriesComponentComponent implements OnInit {
    @Input() group: any;
    @Input() groups_selected: any = {};
    @Input() series: any;

    constructor(public appScope: AppScope,
                public dialog: MatDialog) {
    }

    ngOnInit(): void {
    }

    //TODO: is this used??
    voidEvent($event){
        $event.stopPropagation();
        $event.preventDefault();
    }
}
